import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles
import './index.css';
import logoSrc from './img/logo.png';
import LazyLoad from 'react-lazyload'; // Import LazyLoad


function Education() {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000, // Animation duration
      once: false, // Allow multiple triggers
      mirror: true, // Trigger animations on scroll up as well
    });

    // Refresh AOS on scroll for dynamic content updates
    window.addEventListener('scroll', () => {
      AOS.refresh();
    });

    return () => {
      window.removeEventListener('scroll', () => {
        AOS.refresh();
      });
    };
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text" data-aos="fade-up">
            <h1 className="banner-title" id='titulli'>empowering the next generation</h1>
            <p className="banner-description">
              Through education, Shigjeta LLC transforms talent into professionals. With programs on Shigjetademy,
              Onitech, and Discovery Lab, we provide hands-on non-formal trainings to prepare individuals for the
              global market.
            </p>
            <a href="/ShigjetaAcademyForm" className="banner-button">Discover Our Programs</a>
          </div>
         
        </div>
      </section>
      <div className='video-background'>
      <LazyLoad height={400} offset={100}>

      <video
              className="video"
              id='banner1-video'
              src="/video/ARROW EDUCATION.mp4"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />
        </LazyLoad>
      </div>
      <section className="about-section">
        {/* Section 1: Shigjetademy – Innovative Hub */}
        <div className="about-row" data-aos="fade-right">
          <div className="about-text">
            <h2><strong>Shigjetademy: Shaping Future Talent</strong></h2>
            <p>
              Shigjetademy focuses on professional trainings in branding, marketing, and audience engagement.
              Through practical, real-world projects, our trainees develop skills that position them as future leaders in
              the creative industry.
            </p>
            <ul>
              <p><strong>Trainings in branding, marketing, and strategy development.</strong></p>
              <p><strong>Hands-on projects to deliver real results.</strong></p>
              <p><strong>Focus on critical thinking and practical application.</strong></p>
            </ul>
            <a href='/more-about-us' className="cta-button">Explore Shigjetademy</a>
          </div>
          <div className="about-image" data-aos="fade-left">
            <img src="img/pg4.1.png" alt="Shigjetademy" />
          </div>
        </div>

        {/* Section 2: Onitech – Web & App Development */}
        <div className="about-row reverse" data-aos="fade-up">
          <div className="about-text">
            <h2><strong>Onitech: Building Tomorrow’s Developers</strong></h2>
            <p>
              Onitech specializes in web and app development Trainings. Students gain coding, design, and UX/UI
              expertise through project-based learning, ensuring they are ready for entry-level roles in the tech
              industry.
            </p>
            <ul>
              <p><strong>Frontend Development (React, Vue.js)</strong></p>
              <p><strong>Backend Development (Node.js, Laravel)</strong></p>
              <p><strong>User Experience & Interface Design</strong></p>
            </ul>
            <a href='https://www.onitech.co/' className="cta-button">See Onitech Programs</a>
          </div>
          <div className="about-image" data-aos="fade-right">
            <img src="img/pg4.2.png" alt="Onitech" />
          </div>
        </div>

        {/* Section 3: Discovery Lab – Content & Animation */}
        <div className="about-row" data-aos="fade-left">
          <div className="about-text">
            <h2><strong>Discovery Lab: Content Creation & Storytelling</strong></h2>
            <p>
              Discovery Lab empowers students to create impactful digital media. From animations to film
              production, trainees learn storytelling, visual design, and production techniques to succeed in creative
              industries.
            </p>
            <ul>
              <p><strong>Content Creation for Social Media & Ads</strong></p>
              <p><strong>Animation Techniques and Editing Skills</strong></p>
              <p><strong>Storytelling for Brand Videos and Films</strong></p>
            </ul>
            <a href='https://discovery-lab.org/' className="cta-button">Learn About Discovery Lab</a>
          </div>
          <div className="about-image" data-aos="fade-right">
            <img src="img/pg4.3.png" alt="Discovery Lab" />
          </div>
        </div>

        {/* Section 4: University Collaborations */}
        <div className="about-row reverse" data-aos="fade-up" id='sec2'>
          <div className="about-text">
            <h2><strong>Bridging Education and Real-World Experience</strong></h2>
            <p>
              Shigjeta partners with local and international institutions like Universum University or Kaçanik high schools to provide students
              with structured internship programs. By combining education with real-world projects, we create skilled
              professionals ready for global markets.
            </p>
            <ul>
              <p><strong>Collaboration with high schools and universities.</strong></p>
              <p><strong>Free internship programs for top-performing students.</strong></p>
              <p><strong>Real-world work exposure in tech, branding, and media industries.</strong></p>
            </ul>
            <a href='https://universum-ks.org/' className="cta-button">Explore University Programs</a>
          </div>
          <div className="about-image" data-aos="fade-left">
            <img src="img/pg4.4.png" alt="University Collaborations" />
          </div>
        </div>

        {/* Section 5: Success Stories */}
        <div className="about-row" data-aos="fade-right">
          <div className="about-text">
            <h2><strong>Transforming Talent Into Success</strong></h2>
            <p>
              Our educational programs have empowered individuals to secure professional roles, develop
              businesses, and contribute to the industry. Read the stories of those who began their journeys at
              Shigjeta.
            </p>
            <a href='/blog' className="cta-button">Read Success Stories</a>
          </div>
          <div className="about-image" data-aos="fade-left">
            <img src="img/pg4.5.png" alt="Success Stories" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Education;
